<template lang="pug">
.cp-news-list.w
  .title 最新动态
  .new-wrap
    router-link.left.fl(:to="`news/${articleList[0].id}`", tag="div")
      .text-wrap
        .text {{articleList[0].title}}
    .right
      router-link.item(v-for="(v, index) in articleList", :to="`news/${v.id}`" tag="div", :key="index")
        p {{ v.title }}
        p {{ v.desc }}
        p
          span {{ v.date }}&nbsp;&nbsp;&nbsp;&nbsp;
          span 来源：
          span {{ v.from }}
      router-link.btn(to="/about/news", tag="div")
        span 更多
        icon(iconClass="icongengduo")
</template>
<script>
import { list } from '@/db/news.js'

export default {
  components: {},
  props: {},
  data () {
    return {
      list
    }
  },
  computed: {
    articleList () {
      return list.filter((v, index) => {
        return index < 3
      })
    }
  },
  methods: {}
}
</script>
<style lang="stylus">
.cp-news-list
  padding 108px 20px 148px
  .new-wrap
    margin-top 43px
    color #FFF
    .left
      position relative
      width 510px
      height 300px
      background url('../../../assets/articalPic.png') center / 100% 100% no-repeat
      font-size 18px
      font-weight 400
      cursor pointer
      .text-wrap
        position absolute
        bottom 0
        width 100%
        height 113px
        background:linear-gradient(360deg,rgba(10,32,76,1) 0%,rgba(10,32,76,0) 100%);
        .text
          margin-top 69px
          margin-left 22px
          font-size 18px
    .right
      overflow hidden
      padding-left 26px
      .item
        margin-bottom 16px
        cursor pointer
        &:hover
          p:first-child
            text-decoration underline
        p
          &:first-child
            margin-bottom 3px
            font-size 18px
            font-weight 500
            width 314px
            height 24px
            overflow hidden
            white-space nowrap
            text-overflow ellipsis
          &:nth-child(2)
            width 535px
            height 19px
            margin-bottom 2px
            font-size 14px
            font-weight 300
            color #9EEAFA
            overflow hidden
            white-space nowrap
            text-overflow ellipsis
          &:last-child
            span
              color #59B5C8
      .btn
        width 99px
        height 34px
        border-radius 3px
        border 1px solid rgba(158,234,250,1)
        line-height 34px
        text-align center
        cursor pointer
        span
          color #9EEAFA
          margin-right 7px
</style>
